<!-- App.svelte -->

<script>
    import { navigateTo } from 'svelte-router-spa'
    import TodoItem from "./components/TestItem.svelte";
    import { mmti_dict, pv } from "./store";

    let todos = [
        { id: 9, text: "당신이 넷플릭스를 보고 있을 때, 옆에서 당신과 함께 시청합니다.", opacity: 1.0 },
        { id: 10, text: "노즈워크에 재능이 있습니다.", opacity: 1.0 },
        { id: 11, text: "산책할 때 만나는 모든 사람들에게 귀여움 받고 싶어하는 편입니다.", opacity: 1.0 },
        { id: 12, text: "집에 있는 모든 물건들은 반려견의 장난감입니다.", opacity: 1.0 },
        { id: 13, text: "누울 자리만 있으면 아무데서나 잡니다.", opacity: 1.0 },
        { id: 14, text: "다른 개(사람)이 싫은 티를 내도 마냥 좋다고 들이댑니다.", opacity: 1.0 },
        { id: 15, text: "혼내도 효과가 없습니다.", opacity: 1.0 },
        { id: 16, text: "서열을 굉장히 중시하는 편입니다. (꼰대입니다)", opacity: 0.0 },
    ];

    $pv = 8;
    let i = 0;
    let test_id = '';
    for (i = 0; i < todos.length; i++) {
        test_id = 'mmti' + String(todos[i].id)
        if (test_id in $mmti_dict) {
            $pv += 1;
        }
    } 


    function clickContinue() {
        let allPass = true;

        for (let i = 0; i < todos.length; i++) {
            let todo = todos[i];
            let test_id = 'mmti' + String(todo.id);

            if (test_id in $mmti_dict) {
                todos[i]['textColor'] = 'black';
                todos[i]['textAni'] = '';
            } else {
                allPass = false;
                todos[i]['textColor'] = '#ad1305';
                todos[i]['textAni'] = 'text_shake';

                setTimeout(function(){
                    todos[i]['textAni'] = '';
                }, 500);
            }
        }

        if (allPass) {
            navigateTo('test3');
        } else {
            alert('체크 안 한 항목이 있는지 한 번 더 확인해주세요.');
        } 
    }

</script>

<style lang="scss">
.hero-body {
    background: #f5f5f6;   
}

body, html {
    -webkit-tap-highlight-color: transparent; 
}

.progress {
  border-radius: 0;
}

.progress.is-mmti::-webkit-progress-value {
  background-color: rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-moz-progress-bar {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-ms-fill {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti:indeterminate {
  background-image: linear-gradient(to right, rgba($color: #36765a, $alpha: 1.0) 30%, #ededed 30%);
}

</style>

<html class="has-navbar-fixed-top" style="padding-top: 0">
<body>

<nav class="navbar is-fixed-top" style="background: #f5f5f6; min-height: 0;">
<progress class="progress is-mmti" value="{$pv}" max="40"></progress>
</nav>


<section class="hero is-fullheight">
<div class="hero-body">
<div class="container has-text-centered">
<div class="columns is-desktop">

    <div class="column">

    {#each todos as todo (todo.id)}
    <TodoItem {todo} />
    {/each}

    <div class="container">
    <figure class="image container is-128x128" style="width: 150px; cursor: pointer;" on:click={() => clickContinue() }><img src="/next.png">
    <h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white"><p>다음</p></h1>
    </figure>
    </div>

</div>
</div>
</div>
</section>
</body>
</html>
